import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/bbc83503-089b-44e3-adfb-a45e0a31a6e2_SBINGO9LOGO.png?v=6ee39d1b972f96bc1027ca70c7960135";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/sbingo9#website`,
  name: "Sbingo9",
  url: `${siteUrl}/sbingo9`,
  inLanguage: "en-AU",
  description:
    "Sbingo9 is currently undergoing scheduled maintenance. We'll be back soon with an improved online bingo gaming experience.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/sbingo9?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Sbingo9() {
  return (
    <>
      <SEOHead
        title="Sbingo9 | We'll Be Back Shortly — Maintenance Mode"
        description="Sbingo9 is currently undergoing scheduled maintenance. We'll be back soon with an improved online bingo gaming experience."
        keywords="Sbingo9, online bingo, gaming, maintenance"
        canonicalPath="/sbingo9"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="Sbingo9 Logo"
        siteName="Sbingo9"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="Sbingo9 Logo"
        accentColor="#FF1493"
        glowRgb="255,20,147"
        bgFrom="#1A0010"
        whatsappLink="https://wa.me/61404648730"
        telegramLink="https://t.me/sbingo9official"
      />
    </>
  );
}
